<template>
  <v-card
    outlined
    class="pa-4 my-4"
  >
    <h3 class="text-subtitle-1 mb-2">
      Şirket belgeleri (A.Ş. / Ltd.)
    </h3>
    <v-progress-linear
      v-if="loading"
      indeterminate
    ></v-progress-linear>
    <v-alert
      v-if="error"
      type="error"
      outlined
    >
      {{ error }}
    </v-alert>
    <div
      v-for="document in documents"
      :key="document.type"
      class="d-flex align-center justify-space-between py-2"
    >
      <span>{{ labels[document.type] || document.type }}<br><small>{{ document.id ? document.scanStatus === 'CLEAN' ? 'Yüklendi' : 'Güvenlik taraması tamamlanmadı' : 'Belge yüklenmemiş' }}</small></span>
      <v-btn
        v-if="document.id"
        text
        color="primary"
        @click="selected = document.id"
      >
        Görüntüle
      </v-btn>
    </div>
    <p
      v-if="!loading && !error && !documents.length"
      class="text-caption"
    >
      Bu kayıt için şirket belgesi bulunmuyor.
    </p>
    <v-btn
      text
      :disabled="loading"
      @click="load"
    >
      Yenile
    </v-btn>
    <tax-document-preview
      v-if="selected"
      :key="selected"
      :document-id="selected"
      :headers="headers"
      document-kind="company"
      @close="selected = null"
    ></tax-document-preview>
  </v-card>
</template>
<script>
import axios from 'axios'
import TaxDocumentPreview from './TaxDocumentPreview.vue'
import { resolveApiErrorMessage } from '@/utils/apiErrors'

export default {
  components: { TaxDocumentPreview },
  props: { userId: { type: [Number, String], default: null }, withdrawalId: { type: [Number, String], default: null }, headers: { type: Object, required: true } },
  data: () => ({
    documents: [],
    loading: false,
    error: '',
    selected: null,
    serial: 0,
    labels: {
      TRADE_REGISTRY: 'Ticaret Sicil Gazetesi', ACTIVITY_CERTIFICATE: 'Faaliyet Belgesi (son 6 ay)', SIGNATURE_CIRCULAR: 'İmza Sirküleri', BANK_ACCOUNT_PROOF: 'IBAN ve Hesap Adı Belgesi', TAX_PLATE: 'Vergi Levhası (son yıl)',
    },
  }),
  watch: { userId: 'load', withdrawalId: 'load' },
  created() { this.load() },
  beforeDestroy() { this.serial += 1 },
  methods: {
    async load() {
      this.serial += 1
      const { serial } = this
      this.selected = null
      this.documents = []
      if (!this.userId && !this.withdrawalId) return
      this.loading = true
      this.error = ''
      try {
        const base = `${process.env.VUE_APP_BASE_API_URL}admin/company-documents`
        const response = await axios.get(this.withdrawalId ? `${base}/withdrawals/${this.withdrawalId}` : base, { headers: this.headers, params: this.withdrawalId ? undefined : { userId: this.userId } })
        if (serial === this.serial) this.documents = response.data?.data?.documents || []
      } catch (failure) {
        if (serial === this.serial) this.error = resolveApiErrorMessage(failure, 'Şirket belgeleri alınamadı.')
      } finally {
        if (serial === this.serial) this.loading = false
      }
    },
  },
}
</script>
